import type { IssueMeta } from "@/types/lex";

/**
 * Static 30-day catalog. Themes are derived from the source TOEIC book and
 * mirror PROGRESS.md in the extraction repo. Word counts are fixed at 40 per
 * day per the book's structure.
 *
 * This file is the single source of truth for "what days exist and what they
 * are called". Per-word content lives in the JSON files served from R2.
 */
export const ISSUES: readonly IssueMeta[] = [
  { day: 1,  theme_en: "TOURISM",                    theme_vi: "Du lịch",                       total: 40 },
  { day: 2,  theme_en: "ACCOMMODATIONS & FOOD",      theme_vi: "Chỗ ở và ăn uống",              total: 40 },
  { day: 3,  theme_en: "TRANSPORTATION",             theme_vi: "Giao thông",                    total: 40 },
  { day: 4,  theme_en: "STORES",                     theme_vi: "Các loại cửa hàng",             total: 40 },
  { day: 5,  theme_en: "PURCHASE & WARRANTY",        theme_vi: "Mua hàng & bảo hành",           total: 40 },
  { day: 6,  theme_en: "PERFORMANCE",                theme_vi: "Biểu diễn nghệ thuật",          total: 40 },
  { day: 7,  theme_en: "EXHIBITIONS & MUSEUMS",      theme_vi: "Triển lãm & Bảo tàng",          total: 40 },
  { day: 8,  theme_en: "ARTS",                       theme_vi: "Nghệ thuật",                    total: 40 },
  { day: 9,  theme_en: "MEDIA",                      theme_vi: "Truyền thông",                  total: 40 },
  { day: 10, theme_en: "REAL ESTATE",                theme_vi: "Bất động sản",                  total: 40 },
  { day: 11, theme_en: "SHIPPING",                   theme_vi: "Chuyển hàng",                   total: 40 },
  { day: 12, theme_en: "HEALTH",                     theme_vi: "Y tế",                          total: 40 },
  { day: 13, theme_en: "COMMUNITY",                  theme_vi: "Cộng đồng",                     total: 40 },
  { day: 14, theme_en: "ENVIRONMENT",                theme_vi: "Môi trường",                    total: 40 },
  { day: 15, theme_en: "CONSTRUCTION",               theme_vi: "Xây dựng",                      total: 40 },
  { day: 16, theme_en: "BUILDINGS",                  theme_vi: "Các tòa nhà",                   total: 40 },
  { day: 17, theme_en: "WORKPLACE",                  theme_vi: "Nơi làm việc",                  total: 40 },
  { day: 18, theme_en: "OFFICE EQUIPMENT",           theme_vi: "Thiết bị văn phòng",            total: 40 },
  { day: 19, theme_en: "OFFICE TASKS",               theme_vi: "Công việc văn phòng",           total: 40 },
  { day: 20, theme_en: "RECRUITMENT",                theme_vi: "Tuyển dụng",                    total: 40 },
  { day: 21, theme_en: "PROMOTION",                  theme_vi: "Sự thăng tiến",                 total: 40 },
  { day: 22, theme_en: "INSTRUCTIONS & REGULATIONS", theme_vi: "Hướng dẫn và quy định",         total: 40 },
  { day: 23, theme_en: "EVENTS",                     theme_vi: "Sự kiện",                       total: 40 },
  { day: 24, theme_en: "MARKETING",                  theme_vi: "Marketing",                     total: 40 },
  { day: 25, theme_en: "MEETING",                    theme_vi: "Cuộc họp",                      total: 40 },
  { day: 26, theme_en: "PRODUCTION",                 theme_vi: "Sản xuất",                      total: 40 },
  { day: 27, theme_en: "ACCOUNTING",                 theme_vi: "Kế toán",                       total: 40 },
  { day: 28, theme_en: "FINANCE",                    theme_vi: "Tài chính",                     total: 40 },
  { day: 29, theme_en: "MANAGEMENT",                 theme_vi: "Quản lý",                       total: 40 },
  { day: 30, theme_en: "ECONOMY",                    theme_vi: "Nền kinh tế",                   total: 40 },
];

/**
 * Set of days where the day-NN.json is known to exist on R2. Days outside
 * this set render in the UI as "locked" / upcoming. Update this when new
 * days are uploaded to R2 — keeps the catalog and reality in sync.
 */
export const AVAILABLE_DAYS: ReadonlySet<number> = new Set(
  Array.from({ length: 30 }, (_, i) => i + 1)
);

export function getIssue(day: number): IssueMeta | undefined {
  return ISSUES.find((i) => i.day === day);
}
